import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createRef, memo, } from 'react';
import { Icon, } from '../Icon';
import { sizes, types, } from './constants';
import useIconButtonStyles from './useIconButtonStyles';
const iconSizes = {
    [sizes.extraLarge]: 'medium',
    [sizes.large]: 'small',
    [sizes.medium]: 'extraSmall',
};
const defaultProps = {
    inputRef: createRef(),
    onBlur: () => { },
    onClick: () => { },
    onFocus: () => { },
    onKeyDown: () => { },
    onKeyUp: () => { },
    onMouseDown: () => { },
    onMouseLeave: () => { },
    onMouseUp: () => { },
    onTouchEnd: () => { },
    onTouchMove: () => { },
    onTouchStart: () => { },
    size: sizes.medium,
    type: types.primary,
};
const IconButton = ({ disabled, iconType, inputRef = defaultProps.inputRef, label, onBlur = defaultProps.onBlur, onClick = defaultProps.onClick, onFocus = defaultProps.onFocus, onKeyDown = defaultProps.onKeyDown, onKeyUp = defaultProps.onKeyUp, onMouseDown = defaultProps.onMouseDown, onMouseLeave = defaultProps.onMouseLeave, onMouseUp = defaultProps.onMouseUp, onTouchEnd = defaultProps.onTouchEnd, onTouchMove = defaultProps.onTouchMove, onTouchStart = defaultProps.onTouchStart, size = defaultProps.size, type = defaultProps.type, }) => {
    const buttonStyles = useIconButtonStyles({
        modifier: type,
        size,
    });
    return (_jsx("button", Object.assign({ "aria-label": label, css: buttonStyles, disabled: disabled, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, ref: inputRef, type: "button" }, { children: _jsx(Icon, { size: iconSizes[size], type: iconType }) })));
};
const MemoizedIconButton = memo(IconButton);
export { MemoizedIconButton as IconButton };
// MC-1068 Temporary hack for Storybook.
export default IconButton;
